function parseBooleanFlag(value, defaultValue = false) {
    if (typeof value !== 'string') {
        return defaultValue;
    }

    const normalized = value.trim().toLowerCase();
    if (['1', 'true', 'yes', 'on'].includes(normalized)) {
        return true;
    }

    if (['0', 'false', 'no', 'off'].includes(normalized)) {
        return false;
    }

    return defaultValue;
}

/** Spread shared-side arrow entry points evenly along the card side. On by default. */
export function isChartSpreadEntryPointsEnabled() {
    return parseBooleanFlag(process.env.REACT_APP_CHART_SPREAD_ENTRY_POINTS, true);
}

export const chartSpreadEntryPointsEnabled = isChartSpreadEntryPointsEnabled();

/** Dim cards and arrows outside the click/autoselect focus set. On by default. */
export function isChartFocusConnectedEnabled() {
    return parseBooleanFlag(process.env.REACT_APP_CHART_FOCUS_CONNECTED, true);
}

export const chartFocusConnectedEnabled = isChartFocusConnectedEnabled();
